export default {
    'linking-materials-to-specializations': 'Linking materials to specializations',
    'add-new-specialty': 'Add new specialty',
    'this-specialty': 'this specialty',
    'edit-specialty': 'Edit specialty'
}